<template>
  <section class="height-100-p">
    <el-table
      :data="loads.deliverTo.list"
      v-loading="loads.deliverTo.loadingSearch"
      id="deliverToLoads-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange"
      stripe
    >
      <el-table-column
        prop="origin"
        :label="$t('outbound.loads.origin')"
        :min-width="3"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="shipDate"
        :label="$t('outbound.loads.shipDate')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.shipDate" placement="top">
            <span> {{ scope.row.shipDate | moment(dateDisplayFormat) }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="loadNumber"
        :label="$t('outbound.loads.loadNumber')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.loadNumber" class="item" effect="dark" :content="scope.row.loadNumber" placement="top">
            <span> {{ scope.row.loadNumber }} </span>
          </el-tooltip>
          <span v-else>
            <receiving-detail-dialog :currentRow="scope.row"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="numberOfUnits"
        :label="$t('outbound.loads.numberOfUnits')"
        :min-width="5"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        :label="$t('outbound.loads.eta')"
        :min-width="3"
        align="center"
        sortable="custom"
        :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <span v-if="scope.row.hideEta">
           <span v-if="!scope.row.delivery">
             {{ $t('outbound.loads.hideEta') }}
           </span>
          </span>
          <span v-else>
            {{ scope.row.eta | moment(dateTimeDisplayFormat) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="delivery"
        :label="$t('outbound.loads.delivered')"
        :min-width="5"
        align="center"
        sortable="custom"
        :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <span>
            {{ scope.row.delivery | moment(dateTimeDisplayFormat) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :min-width="5"
        :label="$t('outbound.loads.ccnBol')"
        align="center"
        header-align="center">
        <template slot-scope="scope">
          <print-ccn-bol v-if="scope.row.loadId > 0 && scope.row.dropId > 0 && scope.row.billOfLadingId > 0" :drop-id="scope.row.dropId" :bol-id="scope.row.billOfLadingId" />
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="loads.deliverTo.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('outbound.loads.totalLabel') }}</span>
           {{ loads.deliverTo.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="loads.deliverTo.actualFilters.rows"
        :current-page.sync="loads.deliverTo.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="loads.deliverTo.total"
        layout="slot, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import { LOADS_DELIVER_TO_SEARCH } from '@/store/actions';
import ReceivingDetailDialog from './components/ReceivingDetailDialog';
import PrintCcnBol from './components/PrintCcnBol';

export default {
  name: 'DeliverToLoadsSummarySection',
  components: { ReceivingDetailDialog, PrintCcnBol },
  computed: {
    ...mapGetters(['loads']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    },
    dateTimeDisplayFormat() {
      return constants.DATE_TIME.DEFAULT_DISPLAY_FORMAT;
    }
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSortChange({ prop, order }) {
      this.$store.dispatch(LOADS_DELIVER_TO_SEARCH, { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(LOADS_DELIVER_TO_SEARCH, { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSearchChangePage(val) {
      this.$store.dispatch(LOADS_DELIVER_TO_SEARCH, { page: val });
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#deliverToLoads-data-list {
  .el-table__empty-text {
      line-height: 15px;
      width: 100%;
  }
}
.mobile {
  .app-view-container {
    margin: 15px 0px;
  }
  .pagination-footer .el-pagination__total {
    top: 5px;
  }
  .el-pagination {
    padding-top: 25px;
  }
  .app-view-title {
    margin-top: 30px;
    margin-left: 15px;
  }
  .el-dialog {
    width: 100% !important;
  }
  .el-dialog__body {
    padding: 20px 5px;
  }
}
</style>
